

const storage = {
    code_verifier: "code_verifier",
    access_token: "access_token",
    refresh_token: "refresh_token",
    code: "code",
    user: "user",
    company_uuid: "company_uuid",
    profile_rama: "profile_rama",
    query_path: "query_params",
    path_redirect: "path_redirect"
};

export default {
    // Add common config values here
    MAX_ATTACHMENT_SIZE: 5000000,
    ...storage
};